import {i18n} from "ui/i18n";
import SendEmail from "ui/desktop/dialogs/send-email/SendEmail";
import {parseAuthorName} from "ui/helpers/parsers";
import {formatHtmlToPlainText} from "ui/helpers/formatters";

export default class SendDeclineEmail extends SendEmail {
	/**
	 * @param {string} sceneName
	 * @param {string[]} authors
	 */
	constructor(sceneName, authors) {
		const author = parseAuthorName(authors[0] || '');
		super(
			author.email,
			i18n('emails.decline-scene.subject', sceneName),
			formatHtmlToPlainText(i18n('emails.decline-scene.body', author.name, sceneName)),
		);
	}
}
